import { notification, message } from 'antd';
import viaIntl from '../../../contexts/via-intl';

export const ADD_VIA_MESSAGE = 'ADD_VIA_MESSAGE';

/**
 * An action that creates a new message in the application.
 * @param {string} antMessageType The message type. This is used by ant.
 * @param {string} intlKey The message translation key. This is used by react-intl.
 * @param {object} [intlValues] The message values in a keyed object. This is used by react-intl.
 * @returns {string} The id of the message.
 */
export function addMessage(antMessageType, intlKey, intlValues = {}) {
  return () => {
    const { intl } = viaIntl;

    message[antMessageType](intl.formatMessage({ id: intlKey }, intlValues));
  };
}

/**
 * An action that creates a new notification in the application.
 * @returns {string} The generated if for the notification.
 * @example const notificationId = dispatch(addNotification({ type: 'error', message: 'test' }));
 */
export function addNotification(
  antNotificationType, antDuration, intlTitleKey, intlTitleValues, intlDescKey, intlDescValues,
) {
  return () => {
    const { intl } = viaIntl;

    notification.open({
      type: antNotificationType,
      duration: antDuration,
      message: intl.formatMessage({ id: intlTitleKey }, intlTitleValues),
      description: intl.formatMessage({ id: intlDescKey }, intlDescValues),
    });
  };
}
